export const messages = {
  createSuccess: "Model profile successfully created.",
  createFail : "Error occured while creating model profile.",
  updateSuccess: "Model profile successfully updated.",
  updateFail : "Error occured while updating model profile.",
  publishSuccess: "Model profile successfully published on SFCC.",
  publishError: "Error occured while publishing model profile on SFCC.",
  duplicateModelCode: "Model Code already exists. If you want continue it will override existing model profile details!"
}
